"use strict";

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var cx = require("classnames");
var graphcool_styles_1 = require("graphcool-styles");
var ViewAs = function ViewAs(_a) {
  var selectedViewer = _a.selectedViewer,
      onChangeViewer = _a.onChangeViewer,
      showSelectUser = _a.showSelectUser;
  return React.createElement(
    "div",
    { className: "root", "data-jsx": 2745537961
    },
    React.createElement(_style2.default, {
      styleId: 2745537961,
      css: ".root[data-jsx=\"2745537961\"] {color: rgba(255, 255, 255, .25);}.viewer[data-jsx=\"2745537961\"] {padding: 5px 13px 6px 13px;margin: 0 -2px;background-color: #08131B}.viewer[data-jsx=\"2745537961\"].active[data-jsx=\"2745537961\"] {padding: 7px 9px 8px 9px;z-index: 2;}.fw6,\n.root[data-jsx=\"2745537961\"] {font-weight: 600;}.flex,\n.root[data-jsx=\"2745537961\"],\n.chooser[data-jsx=\"2745537961\"],\n.viewer[data-jsx=\"2745537961\"] {display: -ms-flexbox;display: flex;}.itemsCenter,\n.root[data-jsx=\"2745537961\"],\n.chooser[data-jsx=\"2745537961\"],\n.viewer[data-jsx=\"2745537961\"] {-webkit-box-align: center;-ms-flex-align: center;-ms-grid-row-align: center;align-items: center;}.ml16,\n.chooser[data-jsx=\"2745537961\"] {margin-left: 16px;}.flex,\n.root[data-jsx=\"2745537961\"],\n.chooser[data-jsx=\"2745537961\"],\n.viewer[data-jsx=\"2745537961\"] {display: -ms-flexbox;display: flex;}.itemsCenter,\n.root[data-jsx=\"2745537961\"],\n.chooser[data-jsx=\"2745537961\"],\n.viewer[data-jsx=\"2745537961\"] {-webkit-box-align: center;-ms-flex-align: center;-ms-grid-row-align: center;align-items: center;}.br2,\n.viewer[data-jsx=\"2745537961\"] {border-radius: 2px;}.relative,\n.viewer[data-jsx=\"2745537961\"] {position: relative;}.pointer:hover,\n.viewer[data-jsx=\"2745537961\"]:hover {cursor: pointer;}.ttu,\n.viewer[data-jsx=\"2745537961\"] {text-transform: uppercase;}.flex,\n.root[data-jsx=\"2745537961\"],\n.chooser[data-jsx=\"2745537961\"],\n.viewer[data-jsx=\"2745537961\"] {display: -ms-flexbox;display: flex;}.itemsCenter,\n.root[data-jsx=\"2745537961\"],\n.chooser[data-jsx=\"2745537961\"],\n.viewer[data-jsx=\"2745537961\"] {-webkit-box-align: center;-ms-flex-align: center;-ms-grid-row-align: center;align-items: center;}.bgLightGray,\n.viewer[data-jsx=\"2745537961\"].active[data-jsx=\"2745537961\"] {background-color: #c3bfc4;}.darkerBlue,\n.viewer[data-jsx=\"2745537961\"].active[data-jsx=\"2745537961\"] {color: #0f202e;}.ml6,\n.viewer-text[data-jsx=\"2745537961\"] {margin-left: 6px;}.nowrap,\n.viewer-text[data-jsx=\"2745537961\"] {white-space: nowrap;}"
    }),
    React.createElement(
      "div",
      { className: "nowrap", "data-jsx": 2745537961
      },
      "View As"
    ),
    React.createElement(
      "div",
      { className: "chooser", "data-jsx": 2745537961
      },
      React.createElement(
        "div",
        { className: cx('viewer', {
            'active': selectedViewer === 'ADMIN'
          }), onClick: function onClick() {
            return onChangeViewer('ADMIN');
          }, "data-jsx": 2745537961
        },
        "Admin"
      ),
      React.createElement(
        "div",
        { className: cx('viewer', {
            'active': selectedViewer === 'EVERYONE'
          }), onClick: function onClick() {
            return onChangeViewer('EVERYONE');
          }, "data-jsx": 2745537961
        },
        React.createElement(graphcool_styles_1.Icon, { src: require('graphcool-styles/icons/fill/world.svg'), color: selectedViewer === 'EVERYONE' ? graphcool_styles_1.$v.darkerBlue : graphcool_styles_1.$v.white30, width: 14, height: 14 }),
        React.createElement(
          "div",
          { className: "viewer-text", "data-jsx": 2745537961
          },
          "Everyone"
        )
      ),
      showSelectUser && React.createElement(
        "div",
        { className: cx('viewer', {
            'active': selectedViewer === 'USER'
          }), onClick: function onClick() {
            return onChangeViewer('USER');
          }, "data-jsx": 2745537961
        },
        React.createElement(graphcool_styles_1.Icon, { src: require('graphcool-styles/icons/fill/user.svg'), color: selectedViewer === 'USER' ? graphcool_styles_1.$v.darkerBlue : graphcool_styles_1.$v.white30, width: 14, height: 14 }),
        React.createElement(
          "div",
          { className: "viewer-text", "data-jsx": 2745537961
          },
          "Select User"
        )
      )
    )
  );
};
exports.default = ViewAs;


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/GraphiQL/ResultHeader/ViewerChooser.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/GraphiQL/ResultHeader/ViewerChooser.js
// module chunks = 0